import { HttpParams } from "@angular/common/http";

export const timeout = (ms: number = 0): Promise<void> => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
}
export function getValuesFromEnum<T>(enumType: T) {
    return Object.keys(enumType).filter(s => !isNaN(Number(s))).map(s => Number(s))
}

export function deepCopy<T>(obj: T): T {
    if (Array.isArray(obj)) {
        return obj.map(deepCopy) as unknown as T;
    } else if (obj && typeof obj === "object") {
        const copy: Record<string, any> = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                copy[key] = deepCopy(obj[key]);
            }
        }
        return copy as T;
    }
    return obj;
}

export function getOptionsQueryParams(params: Object): { params: HttpParams } {
    if (!params) {
        return;
    }

    const options = { params: {} as HttpParams };

    Object.keys(params).forEach(key => {
        const value = params[key] instanceof Date
            ? (params[key] as Date).toISOString()
            : params[key] as string | number | boolean;

        options.params[key] = value;
    })

    return options;
}

export function getNestedQueryOptionsParams(queryOptions: Object): { params: HttpParams } {
        let params = new HttpParams();

        for (const key in queryOptions) {
            if (queryOptions.hasOwnProperty(key)) {
                const value = queryOptions[key];
                if (typeof value === 'object') {
                    // Handle nested objects
                    for (const nestedKey in value) {
                        if (value.hasOwnProperty(nestedKey)) {
                            params = params.append(`${key}.${nestedKey}`, value[nestedKey]);
                        }
                    }
                } else {
                    params = params.append(key, value);
                }
            }
        }

    return { params };
}

export function setCookie(cname, cvalue, exdays): void {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname): string {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

